import Close from '@mui/icons-material/Close'
import MuiDialogTitle from '@mui/material/DialogTitle'

import { Heading3 } from '../../../data-display/typography/Typography'
import { IconButton } from '../../../inputs/icon-button'

import { type JSX, type PropsWithChildren } from 'react'

export type DialogTitleProps = PropsWithChildren<{
  title: JSX.Element | string
  id?: string
  onClose?: () => void
  closeDisabled?: boolean
  withSeparator?: boolean
}>

export const DialogTitle = (props: DialogTitleProps) => {
  const {
    title,
    children,
    onClose,
    closeDisabled = false,
    withSeparator,
    ...other
  } = props

  return (
    <MuiDialogTitle
      sx={(theme) => ({
        p: 2,
        ...(withSeparator && {
          borderBottom: `1px solid ${theme.palette.border.subtle}`,
        }),
      })}
      {...other}
    >
      <Heading3 component="span">{title}</Heading3>
      {children}
      {(onClose || closeDisabled) && (
        <IconButton
          ariaLabel="close"
          onClick={closeDisabled ? undefined : onClose}
          disabled={closeDisabled}
          edge="end"
          size="small"
          sx={
            closeDisabled
              ? { '&.Mui-disabled': { color: 'text.disabled' } }
              : undefined
          }
        >
          <Close />
        </IconButton>
      )}
    </MuiDialogTitle>
  )
}
